module.exports = __webpack_public_path__ + "img/document-icon.ffd6aedd.svg";